import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { pure } from '@dbk/ui-react-utils';

import { Currency } from '../../common/number';
import { Card, CardBody } from '@dbk/ui-card';

import Text from '../../common/text';

import styles from './value-header.styles';

function ValueHeader({
  title,
  value,
  valueUnit
}) {
  return (
    <Card testID="value-container">
      <CardBody >
        <View>
          <Text style={styles.marketValueLabel} testID="market-value-label">{title}</Text>
          <View id="text_currency_valueHeader_test">
          <Currency
            renderProps={{
              size: 'normal',
              style: styles.marketValueText,
              testID: 'market-value',
            }}
            currency={valueUnit}
            value={value}
          />
          </View>
        </View>
      </CardBody>
    </Card>
  );


}

ValueHeader.propTypes = {
  value: PropTypes.number,
  valueUnit: PropTypes.string,
};

export default pure(ValueHeader);
